import React, { useState, useEffect } from "react";
import CoverSection from "../components/CoverSection";
import Footer from "../components/Footer";
import InfoSection from "../components/InfoSection";
import InfoSection2 from "../components/InfoSection2";
import { aboutObj, signupObj } from "../components/InfoSection/Data";
import { discoverObj, signupObj2 } from "../components/InfoSection2/Data";

import Navbar from "../components/Navbar";
import Services from "../components/Services";
import Blog from "../components/Blog";
import Gallery from "../components/Gallery";
import Contact from "../components/Contact";
import AppDownloadDialog from "../components/AppDownloadDialog";
import axios from "axios";

//import Sidebar from '../components/Sidebar';

const API_BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:10000';

const LandingPage = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [downloadDialogOpen, setDownloadDialogOpen] = useState(false);
  const [showDownloadButton, setShowDownloadButton] = useState(false);

  useEffect(() => {
    // Check if download feature is enabled
    const checkDownloadFeature = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/app-download/settings`);
        setShowDownloadButton(response.data.isEnabled);
      } catch (error) {
        console.error('Error checking download feature:', error);
        setShowDownloadButton(false);
      }
    };

    checkDownloadFeature();
  }, []);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const handleDownloadClick = () => {
    setDownloadDialogOpen(true);
  };

  const handleCloseDownloadDialog = () => {
    setDownloadDialogOpen(false);
  };

  return (
    <>
      {/*<Sidebar isOpen={isOpen} toggle={toggle} />*/}
      <Navbar toggle={toggle} />
      <CoverSection />
      <InfoSection {...aboutObj} />
      <InfoSection2 {...discoverObj} />
      <Services />
      <InfoSection
        {...signupObj}
        showDownloadButton={showDownloadButton}
        onDownloadClick={handleDownloadClick}
      />
      <Blog />
      <Gallery />
      <Contact />
      <Footer />

      {/* App Download Dialog */}
      <AppDownloadDialog
        open={downloadDialogOpen}
        onClose={handleCloseDownloadDialog}
      />
    </>
  );
};

export default LandingPage;
